import {
    CATEGORY_CSS_MODIFIERS,
    getMetricCategoryKey,
    getMetricCategoryLabel,
    getMetricLabel,
} from '../../utils/metricTags';
import './Analytics.scss';

export default function MetricEventCell({ tag }) {
    const categoryKey = getMetricCategoryKey(tag);
    const modifier = CATEGORY_CSS_MODIFIERS[categoryKey] || 'other';

    return (
        <div className="analytics-event">
            <span className="analytics-event__label">{getMetricLabel(tag)}</span>
            <span className={`analytics-event__badge analytics-event__badge--${modifier}`}>
                {getMetricCategoryLabel(tag)}
            </span>
        </div>
    );
}
